import type { MouseEvent } from 'react';
import gtag from '../analytics/gtag';

export function trackHeaderLinkClick(event: MouseEvent) {
    if (event.target instanceof HTMLAnchorElement) {
        gtag('event', 'header_link_click', {
            link_text: event.target.textContent,
            link_url: event.target.href,
        });
    }
}

export function trackLinkClick({ target, currentTarget }: MouseEvent<HTMLElement>) {
    if (target instanceof HTMLElement) {
        const module = currentTarget.dataset.module;
        const closest = target.closest('a, button');
        if (closest) {
            gtag('event', 'link_click', {
                link_text: closest.textContent,
                link_url: closest instanceof HTMLAnchorElement ? closest.href : undefined,
                module,
            });
        }
    }
}

export function trackFooterLinkClick(event: MouseEvent): void {
    if (event.target instanceof HTMLAnchorElement) {
        gtag('event', 'footer_link_click', {
            link_text: event.target.textContent,
            link_url: event.target.href,
        });
    }
}
